export class UserConfirmationRequestDto {
    public token: string
    public name: string
    public password: string
    public readonly status: string = 'ACTIVE'
    public confirmationRequired?: boolean
}
